// Country values come from the same effective catalogue as every editor.
import { useFields } from "./useFields";

export function useCountries() {
  const catalogue = useFields();
  const field = catalogue.fields.find(
    (item) => item.key === "contact.Country_of_Residence_PL__c",
  );
  return {
    values: [...(field?.options ?? [])],
    isLoading: catalogue.isLoading,
    error: catalogue.error,
  };
}
